module.exports = __webpack_public_path__ + "static/yankee-logo-abdabc13cec9062545a42c2051fb508d.svg";